<script lang="ts" setup>
defineProps<{ isLoading?: boolean }>();

const file = ref<HTMLInputElement>();

const emits = defineEmits(['add-image']);

function onInputChange() {
  if (file.value && file.value.files && file.value.files?.length !== 0) {
    emits('add-image', file.value.files[0]);
  }
}
</script>

<template>
  <span>
    <button
      :class="{ 'opacity-70': isLoading }"
      :disabled="isLoading"
      class="w-full"
      type="button"
      @click="file?.click()"
    >
      <slot />
    </button>

    <input
      id="file"
      ref="file"
      class="hidden"
      type="file"
      @change="onInputChange()"
    />
  </span>
</template>
